export default __webpack_public_path__ + "static/media/HST-SOUNDBAR.51d92a2b.svg";